import {
  TableWrapper,
  Table,
  HeaderCell,
  LabelCell,
  ValueCell,
  MoneyText,
  PercentageText,
  VALUE_COLUMN_WIDTH,
  LABEL_COLUMN_WIDTH
} from './styles'
import { MONTH_HEADER_LABELS, formatPercentage } from './utils'

export default function DreTable({ statement }) {
  const renderValue = (row, value) => (
    row.kind === 'percentage'
      ? <PercentageText>{formatPercentage(value)}</PercentageText>
      : <MoneyText kind={row.kind} value={value}/>
  )

  return (
    <TableWrapper>
      <Table>
        <colgroup>
          <col style={{ width: LABEL_COLUMN_WIDTH }}/>
          {MONTH_HEADER_LABELS.map(label => (
            <col key={label} style={{ width: VALUE_COLUMN_WIDTH }}/>
          ))}
          <col style={{ width: VALUE_COLUMN_WIDTH }}/>
          <col style={{ width: VALUE_COLUMN_WIDTH }}/>
        </colgroup>
        <thead>
          <tr>
            <HeaderCell sticky align='left'>Meses</HeaderCell>
            {MONTH_HEADER_LABELS.map(label => (
              <HeaderCell key={label}>{label}</HeaderCell>
            ))}
            <HeaderCell>Total</HeaderCell>
            <HeaderCell>AV%</HeaderCell>
          </tr>
        </thead>
        <tbody>
          {statement.map(row => (
            <tr key={row.key}>
              <LabelCell kind={row.kind}>{row.label}</LabelCell>
              {row.values.map((value, index) => (
                <ValueCell key={`${row.key}-${index}`} kind={row.kind}>
                  {renderValue(row, value)}
                </ValueCell>
              ))}
              <ValueCell kind={row.kind}>{renderValue(row, row.total)}</ValueCell>
              <ValueCell kind={row.kind}>
                <PercentageText>
                  {row.verticalAnalysis === null ? '-' : formatPercentage(row.verticalAnalysis)}
                </PercentageText>
              </ValueCell>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableWrapper>
  )
}
